import { render, staticRenderFns } from "./BingLiDetail.vue?vue&type=template&id=4cb049e4&scoped=true"
import script from "./BingLiDetail.vue?vue&type=script&lang=js"
export * from "./BingLiDetail.vue?vue&type=script&lang=js"
import style0 from "./BingLiDetail.vue?vue&type=style&index=0&id=4cb049e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb049e4",
  null
  
)

export default component.exports